import { format, parse, parseISO } from "date-fns";
import { mask, tokens } from "maska";
import { cnpjMask, cpfMask, phoneMask } from "./mask.utils";

export const formatDate = (date: Date | string) => {
  if (!date) {
    return "";
  }

  if (typeof date === "string") {
    return format(parseISO(date), "dd/MM/yyyy");
  }

  return format(date, "dd/MM/yyyy");
};

export const parseDate = (date: string) => {
  console.log(parse(date, "dd/MM/yyyy", new Date()))
  return parse(date, "dd/MM/yyyy", new Date());
};

export const formatDateISO = (date: Date | string) => {
  if (!date) {
    return "";
  }

  if (typeof date === "string") {
    return format(parseISO(date), "yyyy-MM-dd");
  }

  return format(date, "yyyy-MM-dd");
};

export const parseTime = (time: string) => {
  time = time.length === 5 ? `${time}:00` : time;
  return parse(time, "HH:mm:ss", new Date());
};

export const formatTime = (time: Date | string, secs = false) => {
  if (!time) {
    return "";
  }

  if (typeof time === "string") {
    time = time.length === 5 ? `${time}:00` : time;
    time = parseTime(time);
  }

  return format(time, `HH:mm${secs ? ":ss" : ""}`);
};

export const formatPhone = (value: string) => {
  const [mask1, mask2] = phoneMask;

  if (value?.length <= 10) {
    return mask(value || "", mask1, tokens);
  }
  return mask(value || "", mask2, tokens);
};

export const formatCNPJ = (cnpj: string) => {
  return mask(cnpj || "", cnpjMask, tokens);
};

export const formatCPF = (cpf: string) => {
  return mask(cpf || "", cpfMask, tokens);
};

export const formatInteger = (value: number) => {
  const result = value || 0;
  return result.toLocaleString("pt-BR");
};

export const formatMoney = (value: number) => {
  const result = value || 0;
  return result.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
};